import React, { useState, useRef, useEffect  } from 'react';
import { Button, TextField, Box, Typography  } from '@mui/material';
import { ReactComponent as Dropdown } from '../../../assets/images/dropdown-arrow.svg';
import { ReactComponent as Upload } from '../../../assets/images/ChatImages/upload.svg';
import { ReactComponent as Bar } from '../../../assets/images/ChatImages/heartbeat-motification-square.svg';
import { ReactComponent as Bubble } from '../../../assets/images/ChatImages/clock-watch-notification.svg';
import { ReactComponent as Light } from '../../../assets/images/ChatImages/Sun.svg';
import { ReactComponent as Dark } from '../../../assets/images/ChatImages/Moon.svg';
import { ReactComponent as Black } from '../../../assets/images/ChatImages/Ellipse 69.svg';
import { ReactComponent as Purple } from '../../../assets/images/ChatImages/Ellipse 70.svg';
import { ReactComponent as Blue } from '../../../assets/images/ChatImages/Ellipse 71.svg';
import { ReactComponent as Sea } from '../../../assets/images/ChatImages/Ellipse 72.svg';
import { ReactComponent as Green } from '../../../assets/images/ChatImages/Ellipse 73.svg';
import { ReactComponent as Yellow } from '../../../assets/images/ChatImages/Ellipse 74.svg';
import { ReactComponent as Orange } from '../../../assets/images/ChatImages/Ellipse 75.svg';
import { ReactComponent as Pink } from '../../../assets/images/ChatImages/Ellipse 76.svg';
import { ReactComponent as BlackGradient } from '../../../assets/images/ChatImages/black-gradient.svg';
import { ReactComponent as PurpleGradient } from '../../../assets/images/ChatImages/purple-gradient.svg';
import { ReactComponent as BlueGradient } from '../../../assets/images/ChatImages/blue-gradient.svg';
import { ReactComponent as SeaGradient } from '../../../assets/images/ChatImages/sea-gradient.svg';
import { ReactComponent as GreenGradient } from '../../../assets/images/ChatImages/green-gradient.svg';
import { ReactComponent as YellowGradient } from '../../../assets/images/ChatImages/yellow-gradient.svg';
import { Upload as UploadIcon } from '@mui/icons-material';
import Input from '../../common/InputField';
import Autocomplete from '@mui/material/Autocomplete';
import './style.css';
import {isValidHexColor} from '../../../utils/index'

function GeneralSettings({color, setColor, gradientOne, gradientTwo, logo, alignment, language, welcomeText, onWelcomeTextChange, onLogoChange, onColorChange, onGradientOneChange, onGradientTwoChange, onAlignmentChange, onLanguageChange, bubble, onBubbleChange, sideSpace, onSideSpaceChange, bottomSpace, onBottomSpaceChange}) {
  
  const [customColor, setCustomColor] = useState(color);
  const [customColorOne, setCustomColorOne] = useState(gradientOne);
  const [customColorTwo, setCustomColorTwo] = useState(gradientTwo);
  const [selectedType, setSelectedType] = useState('flat');

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      onLogoChange(previewUrl, file);
    }
  };


  const handleCustomColorApply = () => {
    if (isValidHexColor(customColor)) {
      onColorChange(customColor);
    }
  };

  const handleGradientColorApply = () => {
    if (isValidHexColor(customColorOne)) {
      onGradientOneChange(customColorOne);
    }
    if (isValidHexColor(customColorTwo)) {
      onGradientTwoChange(customColorTwo);
    }
    setColor(null);
  }

  const handleAlignmentChange = (event, newValue) => {
    onAlignmentChange(newValue);
  };

  const handleLanguageChange = (event, newValue) => {
    onLanguageChange(newValue);
  };

  const handleTextChange = (event) => {
    const text = event.target.value;
    if (text.length <= 24) {
      onWelcomeTextChange(event.target.value);
    }
  };

  const handleBubbleClick = () => {
    onBubbleChange(true);
  };

  const handleBarClick = () => {
    onBubbleChange(false);
  };

  const handleNumberInput = (event) => {
    // Allow only numbers and decimal point (optional)
    const allowedChars = /^[0-9.]+$/;
    const newValue = event.target.value.replace(/[^0-9.]/g, '');

    // Enforce maximum length (optional)
    if (newValue.length > 2) {
      event.target.value = newValue.slice(0, 2);
    } else {
      event.target.value = newValue;
    }

    // Call the provided onChange handler with the sanitized value
    onChange(newValue);
  };

  return (

    <div className="">

      <p className="parInfo">Info</p>

      <div className="Setting-Section-Logo">
        <Button 
          style={{ background: 'transparent', boxShadow: 'none', padding: '0', minWidth: 0  }} 
          variant="contained" 
          component="label"
        >
          {logo ? (
            <img src={logo} style={{ width: "56px", height: "56px", display: "block", borderRadius: '50%' }} alt="Logo" />
          ) : (
            <Upload />
          )}
          <input type="file" hidden onChange={handleLogoUpload} />
        </Button>

        <div className="settings-logo-section">
          <p className="settings-logo-text">Upload Logo</p>
          <p className="settings-logo-requirements">Max. 1500x1000 px jpg, jpeg, png, gif</p>
        </div>
      </div>

      <div className="Settings-Info-Container">
        <div className="Settings-Info-Container-Secondary">
          <Input
            title="Type website address"
            placeholder="Enter website address"
          />
          <button className="settings-tab-button check-button" type="button" >Check</button>
        </div>
        <div className="halfWidth">
          <Input
            title="Welcome text"
            value={welcomeText}
            placeholder=""
            onChange={handleTextChange}
          />
        </div>
      </div>

      <p className="Settings-Line-Bottom" />
      <p className="parInfo">Appearence</p>

      <div className='Settings-Appearance-Container'>
        <div className='Settings-Appearance-Container-Secondary'>
          <div className="halfWidth">
            <label>Minimized window</label>
            <div className="appearance-options">
              <button 
                style={{
                  backgroundColor: !bubble ? '#f3fbff' : 'transparent',
                  border: !bubble ? '1px solid #148dfd' : '1px solid #E5E9EC',
                }}
                className="Appearance-button"
                onClick={handleBarClick}
                ><Bar />Bar
              </button> 
              <button 
              style={{
                backgroundColor: bubble ? '#f3fbff' : 'transparent',
                border: bubble ? '1px solid #148dfd' : '1px solid #E5E9EC',
              }}
                className="Appearance-button"
                onClick={handleBubbleClick}
              ><Bubble />Bubble</button>
            </div>
          </div>

          <div className="halfWidth">
            <label>Theme and colors</label>
            <div className="appearance-options">
              <button className="Appearance-button"><Light />Light</button> 
              <button className="Appearance-button"><Dark />Dark</button>
            </div>
          </div>
        </div>

        <div style={{marginTop: '23px', display: 'flex', justifyContent: 'space-between', gap: '16px'}}>
          <div className={selectedType === 'flat' ? 'halfWidth' : ''}>
            <label
              className={`label ${selectedType === 'flat' ? 'picked' : ''}`}
              onClick={() => setSelectedType('flat')}
            >
              Flat Color
            </label>
            <label
              style={{ marginLeft: '13px' }}
              className={`label ${selectedType === 'gradient' ? 'picked' : ''}`}
              onClick={() => setSelectedType('gradient')}
            >
              Gradient's
            </label>

            {selectedType === 'flat' && (
              <div className="color-options">
                <Black onClick={() => onColorChange('#1C1C1C')} />
                <Purple onClick={() => onColorChange('#6936BD')} />
                <Blue onClick={() => onColorChange('#0059E1')} />
                <Sea onClick={() => onColorChange('#5FC8D6')} />
                <Green onClick={() => onColorChange('#73D943')} />
                <Yellow onClick={() => onColorChange('#FFCA00')} />
                <Orange onClick={() => onColorChange('#FF6D03')} />
                <Pink onClick={() => onColorChange('#D92685')} />
              </div>
            )}

            {selectedType === 'gradient' && (
              <div className="color-options">
                <BlackGradient onClick={() => {onColorChange(''); onGradientOneChange('#1C1C1C'); onGradientTwoChange('#828282')}} />
                <PurpleGradient onClick={() => {onColorChange(''); onGradientOneChange('#6936BD'); onGradientTwoChange('#B80891')}} />
                <BlueGradient onClick={() => {onColorChange(''); onGradientOneChange('#0059E1'); onGradientTwoChange('#1EB9EB')}} />
                <SeaGradient onClick={() => {onColorChange(''); onGradientOneChange('#5FC8D6'); onGradientTwoChange('#D835F2')}} />
                <GreenGradient onClick={() => {onColorChange(''); onGradientOneChange('#73D943'); onGradientTwoChange('#E1B30D')}} />
                <YellowGradient onClick={() => {onColorChange(''); onGradientOneChange('#FFCA00'); onGradientTwoChange('#FF6D03')}} />
              </div>
            )}

          </div>
           {selectedType === 'flat' && (
            <div className="custom-color-picker" style={{width: '50%'}}>
              <Input
                title="Custom Color"
                placeholder="Color code"
                value={customColor}
                onChange={(e) => setCustomColor(e.target.value)}
              />
              <button className="settings-tab-button apply-button" onClick={handleCustomColorApply} type="button" >Apply</button>
            </div>
           )}
           {selectedType === 'gradient' && (
            <div className="custom-color-picker" style={{width: '-webkit-fill-available', marginLeft: '23px'}}>
              <Input
                title="Custom Color"
                placeholder="#1 Color code"
                value={customColorOne}
                onChange={(e) => setCustomColorOne(e.target.value)}
              />
              <Input
                title="Custom Color"
                placeholder="#2 Color code"
                value={customColorTwo}
                onChange={(e) => setCustomColorTwo(e.target.value)}
              />
              <button className="settings-tab-button apply-button" onClick={handleGradientColorApply} type="button" >Apply</button>
            </div>
           )}

        </div>
      </div>

      <p className="Settings-Line-Bottom" />
      <p className="parInfo">Visibility</p>

      <div className='Settings-Visibility-Container'>
        <div className='Settings-Visibility-Container-Secondary'>

          <div className="halfWidth">
            <label >
              Align to
            </label>
            <Autocomplete
              disableClearable
              value={alignment}
              options={['Right', 'Left']}
              sx={{ margin: '10px 0 0 0',
                '& .MuiOutlinedInput-root': {
                  height: '40px', 
                  minHeight: '40px', 
                  cursor: 'pointer',
                },
                '& .MuiInputBase-input': {
                  fontSize: '14px',
                  cursor: 'pointer',
                },
              }}
              size="small"
              onChange={handleAlignmentChange}
              popupIcon={<Dropdown />}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=""
                  InputProps={{
                    ...params.InputProps,
                    onKeyDown: (e) => e.preventDefault(),
                  }}
                />
              )}
            />
          </div>

          <div className="spacingInputs">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                // padding={'11.2px 16px'}
                className="sideSpacx"
                title="Side Space"
                placeholder="0"
                type="number"
                value={sideSpace}
                sx={{ 
                  '& .MuiOutlinedInput-root': {
                    height: '40px', 
                    minHeight: '40px', 
                  }
                }}
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace(/[^0-9]/g, '');

                  if (value.length > 2) {
                    value = value.slice(0, 2);
                  }

                  onSideSpaceChange(value);
                }}
              /><span className="spacingUnits">px</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                // padding={'11.2px 16px'}
                className="bottomSpacx"
                title="Bottom Space"
                placeholder="0"
                type="number"
                value={bottomSpace}
                sx={{ 
                  '& .MuiOutlinedInput-root': {
                    height: '40px', 
                    minHeight: '40px', 
                  }
                }}
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace(/[^0-9]/g, '');

                  if (value.length > 2) {
                    value = value.slice(0, 2);
                  }

                  onBottomSpaceChange(value);
                }}
              /><span className="spacingUnits">px</span>
            </div>
          </div>

        </div>
      </div>

      <p className="Settings-Line-Bottom" />
      <p className="parInfo">Select language</p>

      <div className='Settings-Language-Container'>
        <div style={{width: '50%', paddingRight: '8px', marginBottom: '22px'}}>
          <Autocomplete
            disableClearable
            value={language}
            options={['English', 'French']}
            size="small"
            onChange={handleLanguageChange}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: '40px', 
                minHeight: '40px', 
                cursor: 'pointer',
              },
              '& .MuiInputBase-input': {
                fontSize: '14px',
                cursor: 'pointer',
              },
            }}
            popupIcon={<Dropdown />}
            renderInput={(params) => (
            <TextField
              {...params}
              label=""
              InputProps={{
                ...params.InputProps,
                onKeyDown: (e) => e.preventDefault(),
              }}
            />
            )}
          />
        </div>
      </div>

    </div>
  )
}

export default GeneralSettings;